import { isCurrentDeviceMobile, isMac, isIOS, isTouchDevice } from "dc-preview-utils/src/Utils/DeviceUtils";

export const isMobileClassicViewer = (isMobileModernViewer = false) => isCurrentDeviceMobile() && !isMobileModernViewer;

export const isIOSDevice = () => isIOS() || (isMac() && isTouchDevice());
